import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcadmin.notice.list');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-gsdcadmin-notice-list',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcadmin.notice.list/view.scss */
/* src/app/portal.gsdcadmin.notice.list/view.scss: no such file or directory */`],
})
export class PortalGsdcadminNoticeListComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public boards: any = [];

    public pagination: any = {
        page: 1,
        end: 1,
        start: 1,
    };
    public searchTerm = "";
    public total = 0;
    public mode: any = "";

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow.membership('admin', "/landing");
        await this.load();
    }

    public async load() {
        const { code, data } = await wiz.call("load", { text: this.searchTerm, page: this.pagination.page, mode: this.mode });
        if (code != 200) return await this.service.alert.error("Error!");
        this.boards = data.rows;
        this.pagination.start = Math.floor((this.pagination.page - 1) / 10) * 10 + 1;
        this.pagination.end = data.lastpage;
        this.total = data.total
        await this.service.render();
    }

    private async pageLoad(p: number) {
        this.pagination.page = p;
        await this.load();
    }
}

export default PortalGsdcadminNoticeListComponent;